<template>
    <div class="card dashboard-profile-widget-card">
        <!--    <div class="card profile-header">-->
        <!--        <div class="banner-wrapper" >-->
        <!--            <img :src="getBanner()" id="pick-banner" class="header-image">-->
        <!--            <avatar-cropper v-if="!teacherAccess"-->
        <!--                            @uploaded="handleUploadedBanner"-->
        <!--                            @error="handleError"-->
        <!--                            @uploading="handleUploading"-->
        <!--                            trigger="#pick-banner"-->
        <!--                            upload-url="/profile/uploadbanner"-->
        <!--                            :labels="labels"-->
        <!--                            :cropperOptions="cropperOptions"/>-->
        <!--        </div>-->
        <!--    </div>-->

        <div class="user-avatar-wrapper">
            <img
                class="avatar-image"
                :src="userAvatar" />
            <div
                class="avatar-upload"
                v-if="!teacherAccess">
                <div
                    class="btn-camera-icon avatar-edit-icon"
                    id="pick-avatar"></div>
                <avatar-cropper
                    :labels="labels"
                    trigger="#pick-avatar"
                    upload-url="/profile/uploadavatar"
                    @error="handleError"
                    @uploaded="handleUploaded"
                    @uploading="handleUploading" />
            </div>
        </div>

        <div class="credentials">
            <h4 class="name">
                {{ userCredentialsIn.full_name ? userCredentialsIn.full_name : userCredentialsIn.name }}
            </h4>
            <div class="info-text muted-text">{{ userCredentialsIn.email }}</div>
        </div>
    </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

export default {
    components: { AvatarCropper },
    name: 'design-2021-user-profile-credentials-compact-component',
    props: {
        teacherAccess: {
            type: Boolean,
            default: false,
        },
        userCredentialsIn: Object,
    },
    data() {
        return {
            avatar: this.userCredentialsIn.profile_image_thumb_path,
            avatarHoverImage: this.teacherAccess
                ? this.userCredentialsIn.profile_image_thumb_path
                : '/images/profile_edit.png',
            userAvatar: this.userCredentialsIn.profile_image_thumb_path,
            labels: { submit: this.$t('common.save'), cancel: this.$t('common.cancel') },
            cropperOptions: { aspectRatio: NaN },
        };
    },
    methods: {
        getBanner() {
            if (
                this.userCredentialsIn.profile_banner_image &&
                this.userCredentialsIn.profile_banner_image.file &&
                this.userCredentialsIn.profile_banner_image.file.image
            ) {
                return this.userCredentialsIn.profile_banner_image.file.image.lowres_path;
            } else if (
                this.userCredentialsIn.profile_banner_image &&
                this.userCredentialsIn.profile_banner_image.file
            ) {
                return this.userCredentialsIn.profile_banner_image.file.public_path;
            }

            return this.routes.baseUrl() + '/images/profile-banner.jpg';
        },
        handleUploaded(resp) {
            this.userAvatar = resp.image.file.path;
            this.alert.success(this.$t('profile.photo_saved'), this.$t('profile.the_new_photo_is_saved'));
        },
        handleUploadedBanner(resp) {
            this.userBanner = resp.image.file.path;
            this.alert.success(this.$t('profile.photo_saved'), this.$t('profile.the_new_photo_is_saved'));

            location.reload();
        },
        handleError(resp) {
            this.alert.ajaxError(error);
        },
        handleUploading() {
            this.alert.saving(
                this.$t('profile.save_photo'),
                this.$t('profile.the_photo_will_be_saved_please_wait_a_moment'),
            );
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-profile-widget-card {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border: none;

    &:not(:last-child) {
        border-bottom: 3px dotted $border-color;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    &:last-child {
        .credentials {
            padding-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.user-avatar-wrapper {
    position: relative;
    margin-bottom: 27px;

    img {
        height: 125px;
        width: 125px;
        position: relative;
        border-radius: $border-radius-content;
    }

    .avatar-upload {
        position: absolute;
        bottom: -15px;
        right: -15px;
    }

    .avatar-edit-icon {
        height: 40px;
        width: 40px;
        border-radius: 20px;
        background-color: $primary;
        color: $white;
        font-size: 1.3125rem;
        border: 2px solid $white;

        &:before {
            margin-right: 0;
        }

        &:hover {
            cursor: pointer;
        }
    }

    &:hover {
        img {
            opacity: 0.8;
        }
    }
}

.credentials {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-self: center;
    text-align: center;

    .name {
        font-size: 1.5625rem;
        font-weight: $font-weight-medium;
        margin-bottom: 2px;
    }

    .info-text {
        font-size: 0.8125rem;
    }
}
</style>
